
  import {defineComponent} from "vue";
  import router from "@/router";
  import {NamedRouting} from "@/domain/utils/NamedRouting";

  export default defineComponent({
    name: 'product-list-component',
    props: ['products'],
    methods: {
      moveToProductDetail(productId: number): void {
        router.push(new NamedRouting('ProductDetailView', {productId: productId}));
      }
    }
  });
